// export const REGEX_VALID_IMAGE = /\w+\.(jpeg|jpg|gif|png|webp|svg)$/
export const REGEX_VALID_IMAGE = /^https:\/\/[\w-]+\.[\w-]+(\.[\w-]+)?(\/[\w\-\.\/]*)*?\.(jpeg|jpg|gif|png|webp|svg)$/;
